import React, { memo, useMemo } from "react";
import { isArray } from "lodash";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import CustomLabel from "../../../components/CustomLabel";
import { getFormattedNumber, prettyNumericRound } from "../../../utils";

const CreditLimitSx = { display: "flex" };

function StoreCreditSummary() {
  const total = useSelector((store) => store.total);

  const memoizedCreditLimit = useMemo(() => {
    return `$${getFormattedNumber(
      prettyNumericRound((!!total.creditLimit ? total.creditLimit : 0) || 0)
    )}`;
  }, [total?.creditLimit]);

  const memoizedAvailableCreditLimit = useMemo(() => {
    const finalCost = getFormattedNumber(
      prettyNumericRound(
        !!total?.availableCreditLimit ? total?.availableCreditLimit : 0
      )
    );
    const splittedValue = finalCost?.split("-") || finalCost;
    if (isArray(splittedValue) && splittedValue?.length > 1) {
      return `-$${splittedValue[1]}`;
    }
    return `$${finalCost}`;
  }, [total?.availableCreditLimit]);

  return (
    <Box sx={CreditLimitSx}>
      <CustomLabel
        label="OSO Credit Limit"
        value={memoizedCreditLimit}
        sx={{ mr: 2 }}
      />
      <CustomLabel
        label="Available Credit Limit"
        value={memoizedAvailableCreditLimit}
      />
    </Box>
  );
}

export default memo(StoreCreditSummary);
